export const REQUEST_STARTED = 'REQUEST_STARTED';
export const REQUEST_SUCCEEDED = 'REQUEST_SUCCEEDED';
export const REQUEST_FAILED = 'REQUEST_FAILED';

export const REQUEST_FAILED_NETWORK = 'REQUEST_FAILED_NETWORK';
export const CLEAR_GIVEN_REQUEST = 'CLEAR_GIVEN_REQUEST';
export const NETWORK_ERROR = 'Network Error';
